// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import App from './App';

// import router from './router';
import router from './router/index2';
import ElementUI from 'element-ui';
import '../node_modules/element-ui/lib/theme-chalk/index.css';	//�ֶ����



import store from "./store";
import './styles/common.scss'
import * as filters from './filters' // global filters

import './icons'

import './directive';
import './utils/collectUtil'
import preventClick from './utils/clickStatefrom'  // 防止重复点击按钮
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale';
import zh from './language/zh-CH.json';
import en from './language/en-US.json';
import LanguageConfig from "@/services/language";

if(window.CefSharp){
  CefSharp.BindObjectAsync('BMSService');
  require('./utils/cefUtil')

}


Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale:"zh-CN", // 这里是开始的默认语言，我这里默认是中文
  messages: {
    "zh-CN": {...zh,...zhLocale}, // 这里是在找语言所在的文件位置
    "en-US": {...en,...enLocale},
  },
});
locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换
window.document.documentElement.setAttribute('data-language', "en-US");
setTimeout(()=>{
  LanguageConfig.getCurrent().then(I18n=>{
    i18n.locale=I18n
    window.document.documentElement.setAttribute('data-language', I18n);
  })

},100)





// 修改 el-dialog 默认点击遮罩为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;
// MessageBox弹窗默认点击遮罩为不关闭 prompt,confirm
window.elPrompt=ElementUI.MessageBox.prompt;
ElementUI.MessageBox.prompt= function (){
  let options={};
  // debugger
  if(arguments.length==2){
    options=arguments[1];
  }else if(arguments.length==3){
    options=arguments[2];
  }
  if(! options.closeOnClickModal){
    options.closeOnClickModal=false;
  }
  return window.elPrompt(...arguments)
}
window.elConfirm=ElementUI.MessageBox.confirm;
ElementUI.MessageBox.confirm= function (){
  let options={};
  // debugger
  if(arguments.length==2){
    options=arguments[1];
  }else if(arguments.length==3){
    options=arguments[2];
  }
  if(! options.closeOnClickModal){
    options.closeOnClickModal=false;
  }
  return window.elConfirm(...arguments)
}



Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(ElementUI);	//�ֶ����
// Vue.use(Public_components);


Vue.use(preventClick)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});



Vue.prototype.$EventBus = new Vue();
let theme;
if(!theme){
  theme="theme2";
}
window.document.documentElement.setAttribute('data-theme', theme);
store.dispatch('settings/changeSetting', {
  key: 'theme',
  value: theme
})
new Vue({
  i18n, //把 i18n 挂载到 vue 根实例上components
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})





// WEBPACK FOOTER //
// ./src/main.js